/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef, useState } from 'react'
import { useGLTF } from '@react-three/drei'
import Project from './Project'
import AboutTypeWriter from './AboutTypewriter'
import Text from './Text'
//Images
import absalom from "../portfolioImages/absalom.jpeg"
import allisonRavenWedding from "../portfolioImages/allisonRavenWedding.jpeg"
import beachWithHeather from "../portfolioImages/beachWithHeather.jpeg"
import kawaiBeach from "../portfolioImages/kawaiBeach.jpeg"
import wedding from "../portfolioImages/wedding.jpeg"
import Home from './Home'



export default function Room2({ ...props }) {
  const [hovered, hover] = useState(false)
  const group = useRef()
  const { nodes, materials } = useGLTF(process.env.PUBLIC_URL + "/Room2.glb");
  const linkInNewTab = url => {
    window.open(url, '_blank', 'noopener, noreferrer')
    return console.log(`Opening a link to: ${url}`);;
  };
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-1.19, 10.13, 1.45]} scale={[9.65, 7.69, 7.7]}>
        <mesh geometry={nodes.Cube.geometry} material={materials['Floor.001']} castShadow receiveShadow/>
        <mesh geometry={nodes.Cube_1.geometry} material={materials.Wall} receiveShadow castShadow/>
        <mesh geometry={nodes.Cube_2.geometry} material={materials['Outside Wall']}receiveShadow  castShadow/>
        <mesh geometry={nodes.Cube_3.geometry} material={materials['Wall filling']} />
        <mesh geometry={nodes.Cube_4.geometry} material={materials.Floor} castShadow receiveShadow/>
      </group>
      <group position={[4.25, 6.74, 7.36]} rotation={[0, -Math.PI / 2, 0]} scale={[2.53, 0.15, 4.15]}>
        <mesh geometry={nodes.Cube001.geometry} material={materials['Table bottom']} castShadow/>
        <mesh geometry={nodes.Cube001_1.geometry} material={materials['Table top']} castShadow receiveShadow/>
        <mesh geometry={nodes.Cube001_2.geometry} material={materials['Game Area']}receiveShadow/>
        <mesh geometry={nodes.Cube001_3.geometry} material={materials['Game border']}castShadow receiveShadow/>
      </group>
      <group position={[-10.72, 6.9, 1.45]} scale={[1.5, 0.16, 4.04]}>
        <mesh geometry={nodes.Cube002.geometry} material={materials.DeskLegs} castShadow receiveShadow />
        <mesh geometry={nodes.Cube002_1.geometry} material={materials.TopofDesk} castShadow receiveShadow/>
      </group>
      <mesh geometry={nodes.BookCase.geometry} material={materials['Material.004']} position={[7.39, 8.17, -6.79]} scale={[2.52, 4.19, 0.64]} castShadow receiveShadow />
      <group position={[-12.11, 10.36, 9.22]} scale={[0.09, 0.67, 0.87]}>
        <mesh geometry={nodes.Cube004.geometry} material={materials.FrameColor} onClick={props.cameraAbout} castShadow />
        <mesh geometry={nodes.Cube004_1.geometry} material={materials.InsideFrame} castShadow />
        <mesh>
          <Text position={[1,0,0]} rotation={[0,Math.PI/2,0]} scale={.6} >
        <img onClick={props.cameraAbout} className='aboutMeImgs'
            src={kawaiBeach}
            height="90"
            width="90"
            alt="Kauaii Beach"
                  />
                  </Text>
                  </mesh>
      </group>
      <group position={[-11.28, 8.19, 1.45]} scale={[0.11, 0.93, 1.65]}>
        <mesh geometry={nodes.Cube005.geometry} material={materials.Computer} castShadow/>
        <mesh geometry={nodes.Cube005_1.geometry} material={materials.ComputerScreen} castShadow >
        <Home position={[.5,0,0]} rotation={[0,Math.PI/2,0]} scale={.5} cameraProject={props.cameraProject}/>
          </mesh>
      </group>
      
      <mesh geometry={nodes.Window.geometry} position={[-0.96, 8.07, -9.01]} scale={[2.82, 1.8, 0.1]}>
      <meshPhongMaterial color={'#ADD8E6'} transparent opacity={.5}/>
      </mesh>
      <mesh geometry={nodes.DoggyBed.geometry} material={materials.DoggyBed} position={[1.38, 4.21, -5.69]} rotation={[0, 0.82, 0]} scale={[0.8, 0.64, 0.82]} castShadow receiveShadow/>
      <mesh geometry={nodes.CharacterSheet.geometry} material={materials['Material.005']}  position={[7.48, 7.06, 7.42]} rotation={[0.02, 0.21, -0.07]} scale={[0.66, 0.01, 0.5]} onClick={props.cameraSkills} castShadow/>
      <mesh geometry={nodes.GitHub.geometry} material={materials['Material.009']} position={[-11.24, 7.42, 3.81]} rotation={[-Math.PI, 1.19, -Math.PI]} scale={[0.38, 0.38, 0.2]} onClick={()=> linkInNewTab('https://github.com/SOMarrah')} castShadow />
      <mesh geometry={nodes.LinkedIn.geometry} material={materials['Material.010']} position={[-11.15, 7.42, -0.86]} rotation={[0, 0.81, 0]} scale={[0.38, 0.38, 0.2]} onClick={()=> linkInNewTab('https://www.linkedin.com/in/somarrah/')} castShadow />
      <group position={[-12.11, 9.09, 6.67]} scale={[0.09, 0.67, 0.87]}>
        <mesh geometry={nodes.Cube017.geometry} material={materials.FrameColor} onClick={props.cameraAbout} />
        <mesh geometry={nodes.Cube017_1.geometry} material={materials.InsideFrame} />
        <mesh>
          <Text position={[1,0,0]} rotation={[0,Math.PI/2,0]} scale={.6} >
        <img onClick={props.cameraAbout} className='aboutMeImgs'
            src={wedding}
            height="90"
            width="90"
            alt="My Wedding"
                  />
                  </Text>
                  </mesh>
      </group>
      <group position={[-12.11, 8.02, 9.2]} scale={[0.09, 0.67, 0.87]}>
        <mesh geometry={nodes.Cube018.geometry} material={materials.FrameColor} onClick={props.cameraAbout} />
        <mesh geometry={nodes.Cube018_1.geometry} material={materials.InsideFrame} />
        <mesh>
          <Text position={[1,0,0]} rotation={[0,Math.PI/2,0]} scale={.6} >
        <img onClick={props.cameraAbout} className='aboutMeImgs'
            src={beachWithHeather}
            height="90"
            width="90"
            alt="Kauaii Beach"
                  />
                  </Text>
                  </mesh>
      </group>
      <group position={[-12.11, 6.71, 6.71]} scale={[0.09, 0.67, 0.87]}>
        <mesh geometry={nodes.Cube019.geometry} material={materials.FrameColor} onClick={props.cameraAbout} >
        <mesh>
          <Text position={[1,0,0]} rotation={[0,Math.PI/2,0]} scale={.6} >
        <img onClick={props.cameraAbout} className='aboutMeImgs'
            src={allisonRavenWedding}
            height="90"
            width="90"
            alt="Friend's Wedding"
                  />
                  </Text>
                  </mesh>
        </mesh>
        <AboutTypeWriter position={[4,2,6.3]} rotation={[0,Math.PI/2,0]} scale={.5} start={props.start}/>
        <mesh geometry={nodes.Cube019_1.geometry} material={materials.InsideFrame} />
        
      </group>
      <group position={[-12.11, 5.53, 9.17]} scale={[0.09, 0.67, 0.87]}>
        <mesh geometry={nodes.Cube020.geometry} material={materials.FrameColor} onClick={props.cameraAbout}/>
        <mesh geometry={nodes.Cube020_1.geometry} material={materials.InsideFrame} >
          <mesh>
          <Text position={[1,0,0]} rotation={[0,Math.PI/2,0]} scale={.6} >
        <img onClick={props.cameraAbout} className='aboutMeImgs'
            src={absalom}
            height="90"
            width="90"
            alt="Cute Doggo"
                  />
                  </Text>
                  </mesh>
          </mesh>
      </group>
      <mesh geometry={nodes.Keyboard.geometry} material={materials['Material.011']} position={[-10.14, 7.13, 1.44]} rotation={[0, Math.PI / 2, 0]} scale={[1.29, 0.07, 0.47]} castShadow />
    </group>
  )
}

useGLTF.preload('/Room2.glb')
